// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/response_documents.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { DocumentOperation, DocumentVersion } from "../../docs/v1/docs_pb";
import { WriteAttribution } from "../../common/v1/types_pb";
/**
 * @generated from message mono.projectdata.v1.WorkspaceComment
 */ export class WorkspaceComment extends Message {
    static fromBinary(bytes, options) {
        return new WorkspaceComment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceComment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceComment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceComment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string parent_id = 2;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string author = 3;
   */ _define_property(this, "author", ""), /**
   * @generated from field: string date = 4;
   */ _define_property(this, "date", ""), /**
   * @generated from field: string text = 5;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string quote = 6;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string anchor = 7;
   */ _define_property(this, "anchor", ""), /**
   * @generated from field: string section_title = 8;
   */ _define_property(this, "sectionTitle", ""), /**
   * @generated from field: bool done = 9;
   */ _define_property(this, "done", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkspaceComment, "runtime", proto3);
_define_property(WorkspaceComment, "typeName", "mono.projectdata.v1.WorkspaceComment");
_define_property(WorkspaceComment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "author",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "section_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "done",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDocumentCommentsRequest
 */ export class ListDocumentCommentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentCommentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentCommentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentCommentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentCommentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_anchor = 3;
   */ _define_property(this, "sectionAnchor", ""), /**
   * @generated from field: bool include_done = 4;
   */ _define_property(this, "includeDone", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentCommentsRequest, "runtime", proto3);
_define_property(ListDocumentCommentsRequest, "typeName", "mono.projectdata.v1.ListDocumentCommentsRequest");
_define_property(ListDocumentCommentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_done",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDocumentCommentsResponse
 */ export class ListDocumentCommentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentCommentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentCommentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentCommentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentCommentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.WorkspaceComment comments = 1;
   */ _define_property(this, "comments", []), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentCommentsResponse, "runtime", proto3);
_define_property(ListDocumentCommentsResponse, "typeName", "mono.projectdata.v1.ListDocumentCommentsResponse");
_define_property(ListDocumentCommentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "comments",
            kind: "message",
            T: WorkspaceComment,
            repeated: true
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveDocumentCommentRequest
 */ export class ResolveDocumentCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDocumentCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDocumentCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDocumentCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDocumentCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string comment_id = 3;
   */ _define_property(this, "commentId", ""), /**
   * @generated from field: string base_version_id = 4;
   */ _define_property(this, "baseVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDocumentCommentRequest, "runtime", proto3);
_define_property(ResolveDocumentCommentRequest, "typeName", "mono.projectdata.v1.ResolveDocumentCommentRequest");
_define_property(ResolveDocumentCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "comment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveDocumentCommentResponse
 */ export class ResolveDocumentCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDocumentCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDocumentCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDocumentCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDocumentCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDocumentCommentResponse, "runtime", proto3);
_define_property(ResolveDocumentCommentResponse, "typeName", "mono.projectdata.v1.ResolveDocumentCommentResponse");
_define_property(ResolveDocumentCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddSectionCommentRequest
 */ export class AddSectionCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddSectionCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddSectionCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddSectionCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddSectionCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_anchor = 3;
   */ _define_property(this, "sectionAnchor", ""), /**
   * @generated from field: string quote = 4;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string text = 5;
   */ _define_property(this, "text", ""), /**
   * Stable identity for retries from the rail.
   *
   * @generated from field: string operation_id = 6;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddSectionCommentRequest, "runtime", proto3);
_define_property(AddSectionCommentRequest, "typeName", "mono.projectdata.v1.AddSectionCommentRequest");
_define_property(AddSectionCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddSectionCommentResponse
 */ export class AddSectionCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddSectionCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddSectionCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddSectionCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddSectionCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddSectionCommentResponse, "runtime", proto3);
_define_property(AddSectionCommentResponse, "typeName", "mono.projectdata.v1.AddSectionCommentResponse");
_define_property(AddSectionCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResponseContainerRef
 */ export class ResponseContainerRef extends Message {
    static fromBinary(bytes, options) {
        return new ResponseContainerRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResponseContainerRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResponseContainerRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResponseContainerRef, a, b);
    }
    constructor(data){
        super(), /**
   * "volume" | "rfi"
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * zou project (volume containers)
   *
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 3;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string rfi_response_project_id = 4;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResponseContainerRef, "runtime", proto3);
_define_property(ResponseContainerRef, "typeName", "mono.projectdata.v1.ResponseContainerRef");
_define_property(ResponseContainerRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WorkspaceCapabilities
 */ export class WorkspaceCapabilities extends Message {
    static fromBinary(bytes, options) {
        return new WorkspaceCapabilities().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceCapabilities().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceCapabilities().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceCapabilities, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool can_edit = 1;
   */ _define_property(this, "canEdit", false), /**
   * @generated from field: bool can_comment = 2;
   */ _define_property(this, "canComment", false), /**
   * @generated from field: bool can_approve = 3;
   */ _define_property(this, "canApprove", false), /**
   * @generated from field: bool can_export = 4;
   */ _define_property(this, "canExport", false), /**
   * @generated from field: bool writing_on = 5;
   */ _define_property(this, "writingOn", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkspaceCapabilities, "runtime", proto3);
_define_property(WorkspaceCapabilities, "typeName", "mono.projectdata.v1.WorkspaceCapabilities");
_define_property(WorkspaceCapabilities, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "can_comment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "can_approve",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "can_export",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "writing_on",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WorkspaceDocument
 */ export class WorkspaceDocument extends Message {
    static fromBinary(bytes, options) {
        return new WorkspaceDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string response_document_id = 1;
   */ _define_property(this, "responseDocumentId", ""), /**
   * shirohige document id
   *
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * volume: document | alternate_draft; rfi: response | attachment | alternate_draft | superseded
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string label = 4;
   */ _define_property(this, "label", ""), /**
   * the main document (shirohige id) an alternate draft was copied from
   *
   * @generated from field: string parent_document_id = 5;
   */ _define_property(this, "parentDocumentId", ""), /**
   * @generated from field: string current_version_id = 6;
   */ _define_property(this, "currentVersionId", ""), /**
   * @generated from field: int32 version_count = 7;
   */ _define_property(this, "versionCount", 0), /**
   * @generated from field: string document_type = 8;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: bool is_submission_doc = 9;
   */ _define_property(this, "isSubmissionDoc", false), /**
   * @generated from field: string submission_filename = 10;
   */ _define_property(this, "submissionFilename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkspaceDocument, "runtime", proto3);
_define_property(WorkspaceDocument, "typeName", "mono.projectdata.v1.WorkspaceDocument");
_define_property(WorkspaceDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "response_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "parent_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "is_submission_doc",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "submission_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WorkspaceBudget
 */ export class WorkspaceBudget extends Message {
    static fromBinary(bytes, options) {
        return new WorkspaceBudget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceBudget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceBudget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceBudget, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 words = 1;
   */ _define_property(this, "words", 0), /**
   * @generated from field: int32 word_limit = 2;
   */ _define_property(this, "wordLimit", 0), /**
   * @generated from field: double pages = 3;
   */ _define_property(this, "pages", 0), /**
   * app_xml | estimate | exact
   *
   * @generated from field: string pages_basis = 4;
   */ _define_property(this, "pagesBasis", ""), /**
   * @generated from field: double page_limit = 5;
   */ _define_property(this, "pageLimit", 0), /**
   * @generated from field: int32 words_per_page = 6;
   */ _define_property(this, "wordsPerPage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkspaceBudget, "runtime", proto3);
_define_property(WorkspaceBudget, "typeName", "mono.projectdata.v1.WorkspaceBudget");
_define_property(WorkspaceBudget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "words",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "word_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "pages",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "pages_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "page_limit",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "words_per_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetResponseWorkspaceRequest
 */ export class GetResponseWorkspaceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetResponseWorkspaceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetResponseWorkspaceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetResponseWorkspaceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetResponseWorkspaceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * empty = the first main document
   *
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetResponseWorkspaceRequest, "runtime", proto3);
_define_property(GetResponseWorkspaceRequest, "typeName", "mono.projectdata.v1.GetResponseWorkspaceRequest");
_define_property(GetResponseWorkspaceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetResponseWorkspaceResponse
 */ export class GetResponseWorkspaceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetResponseWorkspaceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetResponseWorkspaceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetResponseWorkspaceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetResponseWorkspaceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * mains first (sort order), then alternates grouped under their parent
   *
   * @generated from field: repeated mono.projectdata.v1.WorkspaceDocument documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: string active_document_id = 2;
   */ _define_property(this, "activeDocumentId", ""), /**
   * newest 20 versions of the active document, with labels
   *
   * @generated from field: repeated mono.docs.v1.DocumentVersion recent_versions = 3;
   */ _define_property(this, "recentVersions", []), /**
   * @generated from field: mono.projectdata.v1.WorkspaceCapabilities capabilities = 4;
   */ _define_property(this, "capabilities", void 0), /**
   * from the WRT-01 analysis; WRT-13 adds limits and exact pages
   *
   * @generated from field: mono.projectdata.v1.WorkspaceBudget budget = 5;
   */ _define_property(this, "budget", void 0), /**
   * analysis comments with done=false and not citations
   *
   * @generated from field: int32 open_comment_count = 6;
   */ _define_property(this, "openCommentCount", 0), /**
   * analysis revisions: insertions + deletions
   *
   * @generated from field: int32 pending_revision_count = 7;
   */ _define_property(this, "pendingRevisionCount", 0), /**
   * WRT-13 (OD-75): "docx" | "pdf" for RFIs, from the RFI's submission_format
   * (rfiPreferredPackageFormat); the Download menu lists it first. "" for volumes.
   *
   * @generated from field: string preferred_package_format = 20;
   */ _define_property(this, "preferredPackageFormat", ""), /**
   * WRT-10: the active document's analysis comments with is_source=true, in
   * document order ("Cited in this document"). Field 21, not the reserved
   * 8-19 range: buf breaking (FILE) rejects shrinking a reserved range.
   *
   * @generated from field: repeated mono.projectdata.v1.WorkspaceCitation citations = 21;
   */ _define_property(this, "citations", []), /**
   * distinct authors of pending tracked revisions: revision count desc, then
   * name; at most 5
   *
   * @generated from field: repeated string pending_revision_authors = 22;
   */ _define_property(this, "pendingRevisionAuthors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetResponseWorkspaceResponse, "runtime", proto3);
_define_property(GetResponseWorkspaceResponse, "typeName", "mono.projectdata.v1.GetResponseWorkspaceResponse");
_define_property(GetResponseWorkspaceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: WorkspaceDocument,
            repeated: true
        },
        {
            no: 2,
            name: "active_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "recent_versions",
            kind: "message",
            T: DocumentVersion,
            repeated: true
        },
        {
            no: 4,
            name: "capabilities",
            kind: "message",
            T: WorkspaceCapabilities
        },
        {
            no: 5,
            name: "budget",
            kind: "message",
            T: WorkspaceBudget
        },
        {
            no: 6,
            name: "open_comment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "pending_revision_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "preferred_package_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "citations",
            kind: "message",
            T: WorkspaceCitation,
            repeated: true
        },
        {
            no: 22,
            name: "pending_revision_authors",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDocumentVersionsRequest
 */ export class ListDocumentVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: int32 page_size = 3;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: string page_token = 4;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentVersionsRequest, "runtime", proto3);
_define_property(ListDocumentVersionsRequest, "typeName", "mono.projectdata.v1.ListDocumentVersionsRequest");
_define_property(ListDocumentVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListDocumentVersionsResponse
 */ export class ListDocumentVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.docs.v1.DocumentVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * @generated from field: string current_version_id = 2;
   */ _define_property(this, "currentVersionId", ""), /**
   * @generated from field: string next_page_token = 3;
   */ _define_property(this, "nextPageToken", ""), /**
   * parallel to versions (same length and order)
   *
   * @generated from field: repeated mono.common.v1.WriteAttribution attributions = 4;
   */ _define_property(this, "attributions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentVersionsResponse, "runtime", proto3);
_define_property(ListDocumentVersionsResponse, "typeName", "mono.projectdata.v1.ListDocumentVersionsResponse");
_define_property(ListDocumentVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: DocumentVersion,
            repeated: true
        },
        {
            no: 2,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "attributions",
            kind: "message",
            T: WriteAttribution,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LabelVersionRequest
 */ export class LabelVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new LabelVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LabelVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LabelVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LabelVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string label = 4;
   */ _define_property(this, "label", ""), /**
   * named | review | final | submitted
   *
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LabelVersionRequest, "runtime", proto3);
_define_property(LabelVersionRequest, "typeName", "mono.projectdata.v1.LabelVersionRequest");
_define_property(LabelVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LabelVersionResponse
 */ export class LabelVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new LabelVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LabelVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LabelVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LabelVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LabelVersionResponse, "runtime", proto3);
_define_property(LabelVersionResponse, "typeName", "mono.projectdata.v1.LabelVersionResponse");
_define_property(LabelVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RestoreDocumentVersionRequest
 */ export class RestoreDocumentVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RestoreDocumentVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreDocumentVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreDocumentVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreDocumentVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string base_version_id = 4;
   */ _define_property(this, "baseVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreDocumentVersionRequest, "runtime", proto3);
_define_property(RestoreDocumentVersionRequest, "typeName", "mono.projectdata.v1.RestoreDocumentVersionRequest");
_define_property(RestoreDocumentVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RestoreDocumentVersionResponse
 */ export class RestoreDocumentVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RestoreDocumentVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreDocumentVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreDocumentVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreDocumentVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreDocumentVersionResponse, "runtime", proto3);
_define_property(RestoreDocumentVersionResponse, "typeName", "mono.projectdata.v1.RestoreDocumentVersionResponse");
_define_property(RestoreDocumentVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetVersionViewSessionRequest
 */ export class GetVersionViewSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetVersionViewSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVersionViewSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVersionViewSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVersionViewSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVersionViewSessionRequest, "runtime", proto3);
_define_property(GetVersionViewSessionRequest, "typeName", "mono.projectdata.v1.GetVersionViewSessionRequest");
_define_property(GetVersionViewSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetVersionViewSessionResponse
 */ export class GetVersionViewSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetVersionViewSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVersionViewSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVersionViewSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVersionViewSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string editor_config_json = 1;
   */ _define_property(this, "editorConfigJson", ""), /**
   * @generated from field: string document_server_url = 2;
   */ _define_property(this, "documentServerUrl", ""), /**
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVersionViewSessionResponse, "runtime", proto3);
_define_property(GetVersionViewSessionResponse, "typeName", "mono.projectdata.v1.GetVersionViewSessionResponse");
_define_property(GetVersionViewSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "editor_config_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_server_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResponseDocumentServiceCreateDraftRequest
 */ export class ResponseDocumentServiceCreateDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResponseDocumentServiceCreateDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResponseDocumentServiceCreateDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResponseDocumentServiceCreateDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResponseDocumentServiceCreateDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * shirohige id of the main document
   *
   * @generated from field: string main_document_id = 2;
   */ _define_property(this, "mainDocumentId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * empty = the main document's current version
   *
   * @generated from field: string from_version_id = 4;
   */ _define_property(this, "fromVersionId", ""), /**
   * @generated from field: string operation_id = 5;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResponseDocumentServiceCreateDraftRequest, "runtime", proto3);
_define_property(ResponseDocumentServiceCreateDraftRequest, "typeName", "mono.projectdata.v1.ResponseDocumentServiceCreateDraftRequest");
_define_property(ResponseDocumentServiceCreateDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "main_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "from_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResponseDocumentServiceCreateDraftResponse
 */ export class ResponseDocumentServiceCreateDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResponseDocumentServiceCreateDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResponseDocumentServiceCreateDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResponseDocumentServiceCreateDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResponseDocumentServiceCreateDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.WorkspaceDocument draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResponseDocumentServiceCreateDraftResponse, "runtime", proto3);
_define_property(ResponseDocumentServiceCreateDraftResponse, "typeName", "mono.projectdata.v1.ResponseDocumentServiceCreateDraftResponse");
_define_property(ResponseDocumentServiceCreateDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: WorkspaceDocument
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResponseDocumentServiceRenameDraftRequest
 */ export class ResponseDocumentServiceRenameDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResponseDocumentServiceRenameDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResponseDocumentServiceRenameDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResponseDocumentServiceRenameDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResponseDocumentServiceRenameDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string draft_document_id = 2;
   */ _define_property(this, "draftDocumentId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResponseDocumentServiceRenameDraftRequest, "runtime", proto3);
_define_property(ResponseDocumentServiceRenameDraftRequest, "typeName", "mono.projectdata.v1.ResponseDocumentServiceRenameDraftRequest");
_define_property(ResponseDocumentServiceRenameDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "draft_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResponseDocumentServiceRenameDraftResponse
 */ export class ResponseDocumentServiceRenameDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResponseDocumentServiceRenameDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResponseDocumentServiceRenameDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResponseDocumentServiceRenameDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResponseDocumentServiceRenameDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.WorkspaceDocument draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResponseDocumentServiceRenameDraftResponse, "runtime", proto3);
_define_property(ResponseDocumentServiceRenameDraftResponse, "typeName", "mono.projectdata.v1.ResponseDocumentServiceRenameDraftResponse");
_define_property(ResponseDocumentServiceRenameDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: WorkspaceDocument
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PromoteDraftRequest
 */ export class PromoteDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new PromoteDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string draft_document_id = 2;
   */ _define_property(this, "draftDocumentId", ""), /**
   * @generated from field: string main_base_version_id = 3;
   */ _define_property(this, "mainBaseVersionId", ""), /**
   * @generated from field: bool archive_after = 4;
   */ _define_property(this, "archiveAfter", false), /**
   * @generated from field: string operation_id = 5;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteDraftRequest, "runtime", proto3);
_define_property(PromoteDraftRequest, "typeName", "mono.projectdata.v1.PromoteDraftRequest");
_define_property(PromoteDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "draft_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "main_base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "archive_after",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PromoteDraftResponse
 */ export class PromoteDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new PromoteDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion main_version = 1;
   */ _define_property(this, "mainVersion", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteDraftResponse, "runtime", proto3);
_define_property(PromoteDraftResponse, "typeName", "mono.projectdata.v1.PromoteDraftResponse");
_define_property(PromoteDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "main_version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ArchiveDraftRequest
 */ export class ArchiveDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string draft_document_id = 2;
   */ _define_property(this, "draftDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveDraftRequest, "runtime", proto3);
_define_property(ArchiveDraftRequest, "typeName", "mono.projectdata.v1.ArchiveDraftRequest");
_define_property(ArchiveDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "draft_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ArchiveDraftResponse
 */ export class ArchiveDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveDraftResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveDraftResponse, "runtime", proto3);
_define_property(ArchiveDraftResponse, "typeName", "mono.projectdata.v1.ArchiveDraftResponse");
_define_property(ArchiveDraftResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ImportDocxVersionRequest
 */ export class ImportDocxVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ImportDocxVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportDocxVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportDocxVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportDocxVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", ""), /**
   * a proposal attachment (volume containers)…
   *
   * @generated from field: string attachment_id = 4;
   */ _define_property(this, "attachmentId", ""), /**
   * …or a tesoro artifact version
   *
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 6;
   */ _define_property(this, "artifactVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportDocxVersionRequest, "runtime", proto3);
_define_property(ImportDocxVersionRequest, "typeName", "mono.projectdata.v1.ImportDocxVersionRequest");
_define_property(ImportDocxVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ImportDocxVersionResponse
 */ export class ImportDocxVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ImportDocxVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportDocxVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportDocxVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportDocxVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportDocxVersionResponse, "runtime", proto3);
_define_property(ImportDocxVersionResponse, "typeName", "mono.projectdata.v1.ImportDocxVersionResponse");
_define_property(ImportDocxVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DownloadDocumentRequest
 */ export class DownloadDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DownloadDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * empty = current
   *
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * the document's own type (docx | xlsx), or pdf (WRT-13: DS ConvertService
   * on a comment-stripped copy when strip_comments)
   *
   * @generated from field: string format = 4;
   */ _define_property(this, "format", ""), /**
   * @generated from field: bool strip_comments = 5;
   */ _define_property(this, "stripComments", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadDocumentRequest, "runtime", proto3);
_define_property(DownloadDocumentRequest, "typeName", "mono.projectdata.v1.DownloadDocumentRequest");
_define_property(DownloadDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "strip_comments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DownloadDocumentResponse
 */ export class DownloadDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DownloadDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string url = 1;
   */ _define_property(this, "url", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */ _define_property(this, "expiresAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DownloadDocumentResponse, "runtime", proto3);
_define_property(DownloadDocumentResponse, "typeName", "mono.projectdata.v1.DownloadDocumentResponse");
_define_property(DownloadDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ----- WRT-13 -----
 *
 * @generated from message mono.projectdata.v1.ResponseDocumentServiceGetExactPageCountRequest
 */ export class ResponseDocumentServiceGetExactPageCountRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResponseDocumentServiceGetExactPageCountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResponseDocumentServiceGetExactPageCountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResponseDocumentServiceGetExactPageCountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResponseDocumentServiceGetExactPageCountRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * empty = current
   *
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResponseDocumentServiceGetExactPageCountRequest, "runtime", proto3);
_define_property(ResponseDocumentServiceGetExactPageCountRequest, "typeName", "mono.projectdata.v1.ResponseDocumentServiceGetExactPageCountRequest");
_define_property(ResponseDocumentServiceGetExactPageCountRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResponseDocumentServiceGetExactPageCountResponse
 */ export class ResponseDocumentServiceGetExactPageCountResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResponseDocumentServiceGetExactPageCountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResponseDocumentServiceGetExactPageCountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResponseDocumentServiceGetExactPageCountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResponseDocumentServiceGetExactPageCountResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 pages = 1;
   */ _define_property(this, "pages", 0), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * the workspace budget recomputed with the measured pages
   *
   * @generated from field: mono.projectdata.v1.WorkspaceBudget budget = 3;
   */ _define_property(this, "budget", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResponseDocumentServiceGetExactPageCountResponse, "runtime", proto3);
_define_property(ResponseDocumentServiceGetExactPageCountResponse, "typeName", "mono.projectdata.v1.ResponseDocumentServiceGetExactPageCountResponse");
_define_property(ResponseDocumentServiceGetExactPageCountResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "budget",
            kind: "message",
            T: WorkspaceBudget
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FixSectionAnchorsRequest
 */ export class FixSectionAnchorsRequest extends Message {
    static fromBinary(bytes, options) {
        return new FixSectionAnchorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FixSectionAnchorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FixSectionAnchorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FixSectionAnchorsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FixSectionAnchorsRequest, "runtime", proto3);
_define_property(FixSectionAnchorsRequest, "typeName", "mono.projectdata.v1.FixSectionAnchorsRequest");
_define_property(FixSectionAnchorsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FixSectionAnchorsResponse
 */ export class FixSectionAnchorsResponse extends Message {
    static fromBinary(bytes, options) {
        return new FixSectionAnchorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FixSectionAnchorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FixSectionAnchorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FixSectionAnchorsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * the new version, or empty when every heading already had an anchor
   *
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FixSectionAnchorsResponse, "runtime", proto3);
_define_property(FixSectionAnchorsResponse, "typeName", "mono.projectdata.v1.FixSectionAnchorsResponse");
_define_property(FixSectionAnchorsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MarkSectionReadyRequest
 */ export class MarkSectionReadyRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkSectionReadyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkSectionReadyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkSectionReadyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkSectionReadyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * Deprecated: ignored; the ready stamp is guarded by the region hash.
   *
   * @generated from field: string base_version_id = 4;
   */ _define_property(this, "baseVersionId", ""), /**
   * The review this is for ("Pink team"); empty skips the version label.
   *
   * @generated from field: string label = 5;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkSectionReadyRequest, "runtime", proto3);
_define_property(MarkSectionReadyRequest, "typeName", "mono.projectdata.v1.MarkSectionReadyRequest");
_define_property(MarkSectionReadyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MarkSectionReadyResponse
 */ export class MarkSectionReadyResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkSectionReadyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkSectionReadyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkSectionReadyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkSectionReadyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * the version the mark applies to
   *
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * the section's ready stamp
   *
   * @generated from field: string ready_region_sha256 = 2;
   */ _define_property(this, "readyRegionSha256", ""), /**
   * @generated from field: string ready_label = 3;
   */ _define_property(this, "readyLabel", ""), /**
   * @generated from field: google.protobuf.Timestamp ready_at = 4;
   */ _define_property(this, "readyAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkSectionReadyResponse, "runtime", proto3);
_define_property(MarkSectionReadyResponse, "typeName", "mono.projectdata.v1.MarkSectionReadyResponse");
_define_property(MarkSectionReadyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "ready_region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ready_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ready_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PutSectionHeadingBackRequest
 */ export class PutSectionHeadingBackRequest extends Message {
    static fromBinary(bytes, options) {
        return new PutSectionHeadingBackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PutSectionHeadingBackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PutSectionHeadingBackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PutSectionHeadingBackRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string volume_id = 2;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PutSectionHeadingBackRequest, "runtime", proto3);
_define_property(PutSectionHeadingBackRequest, "typeName", "mono.projectdata.v1.PutSectionHeadingBackRequest");
_define_property(PutSectionHeadingBackRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PutSectionHeadingBackResponse
 */ export class PutSectionHeadingBackResponse extends Message {
    static fromBinary(bytes, options) {
        return new PutSectionHeadingBackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PutSectionHeadingBackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PutSectionHeadingBackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PutSectionHeadingBackResponse, a, b);
    }
    constructor(data){
        super(), /**
   * the new version
   *
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PutSectionHeadingBackResponse, "runtime", proto3);
_define_property(PutSectionHeadingBackResponse, "typeName", "mono.projectdata.v1.PutSectionHeadingBackResponse");
_define_property(PutSectionHeadingBackResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * WorkspaceCitation is one inserted-source comment in the active document.
 *
 * @generated from message mono.projectdata.v1.WorkspaceCitation
 */ export class WorkspaceCitation extends Message {
    static fromBinary(bytes, options) {
        return new WorkspaceCitation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceCitation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceCitation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceCitation, a, b);
    }
    constructor(data){
        super(), /**
   * 1-based position in document order
   *
   * @generated from field: int32 index = 1;
   */ _define_property(this, "index", 0), /**
   * "{kind}:{id}" from the comment's "[source:<ref>]" token
   *
   * @generated from field: string source_ref = 2;
   */ _define_property(this, "sourceRef", ""), /**
   * the comment text after the token
   *
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * section anchor (bookmark) the comment sits in; "" when outside any section
   *
   * @generated from field: string anchor = 4;
   */ _define_property(this, "anchor", ""), /**
   * @generated from field: string section_title = 5;
   */ _define_property(this, "sectionTitle", ""), /**
   * source_ref starts with "hearsay:"
   *
   * @generated from field: bool is_hearsay = 6;
   */ _define_property(this, "isHearsay", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkspaceCitation, "runtime", proto3);
_define_property(WorkspaceCitation, "typeName", "mono.projectdata.v1.WorkspaceCitation");
_define_property(WorkspaceCitation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "section_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_hearsay",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkspaceSourcesRequest
 */ export class ListWorkspaceSourcesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkspaceSourcesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkspaceSourcesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkspaceSourcesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkspaceSourcesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_anchor = 3;
   */ _define_property(this, "sectionAnchor", ""), /**
   * overrides the derived search text (capped at 2,000 chars)
   *
   * @generated from field: string query = 4;
   */ _define_property(this, "query", ""), /**
   * empty = every kind
   *
   * @generated from field: repeated string kinds = 5;
   */ _define_property(this, "kinds", []), /**
   * honoured only for shanks' service identity with a forwarded human
   *
   * @generated from field: bool include_no_quote_shingles = 6;
   */ _define_property(this, "includeNoQuoteShingles", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkspaceSourcesRequest, "runtime", proto3);
_define_property(ListWorkspaceSourcesRequest, "typeName", "mono.projectdata.v1.ListWorkspaceSourcesRequest");
_define_property(ListWorkspaceSourcesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "include_no_quote_shingles",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListWorkspaceSourcesResponse
 */ export class ListWorkspaceSourcesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkspaceSourcesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkspaceSourcesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkspaceSourcesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkspaceSourcesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * proposals only
   *
   * @generated from field: repeated mono.projectdata.v1.WorkspaceRequirementRef requirements = 1;
   */ _define_property(this, "requirements", []), /**
   * @generated from field: repeated mono.projectdata.v1.WorkspaceSource draw_from = 2;
   */ _define_property(this, "drawFrom", []), /**
   * kinds whose producer failed or timed out (1.5 s each)
   *
   * @generated from field: repeated string unavailable_kinds = 3;
   */ _define_property(this, "unavailableKinds", []), /**
   * sha256 of normalized 8-word shingles of every returned hearsay statement
   * and paraphrase_only text; empty unless the caller is shanks' service
   * identity with a forwarded human principal.
   *
   * @generated from field: repeated string no_quote_shingles = 5;
   */ _define_property(this, "noQuoteShingles", []), /**
   * @generated from field: int32 word_limit = 6;
   */ _define_property(this, "wordLimit", 0), /**
   * @generated from field: double page_limit = 7;
   */ _define_property(this, "pageLimit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkspaceSourcesResponse, "runtime", proto3);
_define_property(ListWorkspaceSourcesResponse, "typeName", "mono.projectdata.v1.ListWorkspaceSourcesResponse");
_define_property(ListWorkspaceSourcesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirements",
            kind: "message",
            T: WorkspaceRequirementRef,
            repeated: true
        },
        {
            no: 2,
            name: "draw_from",
            kind: "message",
            T: WorkspaceSource,
            repeated: true
        },
        {
            no: 3,
            name: "unavailable_kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "no_quote_shingles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "word_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "page_limit",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WorkspaceRequirementRef
 */ export class WorkspaceRequirementRef extends Message {
    static fromBinary(bytes, options) {
        return new WorkspaceRequirementRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceRequirementRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceRequirementRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceRequirementRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string requirement_id = 1;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", ""), /**
   * addressed | partial | missing
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: bool mandatory = 4;
   */ _define_property(this, "mandatory", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkspaceRequirementRef, "runtime", proto3);
_define_property(WorkspaceRequirementRef, "typeName", "mono.projectdata.v1.WorkspaceRequirementRef");
_define_property(WorkspaceRequirementRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "mandatory",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.WorkspaceSource
 */ export class WorkspaceSource extends Message {
    static fromBinary(bytes, options) {
        return new WorkspaceSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceSource, a, b);
    }
    constructor(data){
        super(), /**
   * "{kind}:{id}"; hearsay uses the claim's lineage_id
   *
   * @generated from field: string ref = 1;
   */ _define_property(this, "ref", ""), /**
   * past_performance | past_answer | rfi_answer | touchpoint | capability |
   * person | library_release | lesson_learned | hearsay | black_hat
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string detail = 4;
   */ _define_property(this, "detail", ""), /**
   * verbatim text Insert would copy; empty for hearsay and paraphrase_only
   *
   * @generated from field: string quote_text = 5;
   */ _define_property(this, "quoteText", ""), /**
   * the label written into the source comment
   *
   * @generated from field: string display_label = 6;
   */ _define_property(this, "displayLabel", ""), /**
   * citable | hearsay | paraphrase_only
   *
   * @generated from field: string eligibility = 7;
   */ _define_property(this, "eligibility", ""), /**
   * cp0 score x 100; 0 for kinds that are not indexed in Qdrant
   *
   * @generated from field: int32 similarity_pct = 8;
   */ _define_property(this, "similarityPct", 0), /**
   * @generated from field: string href = 9;
   */ _define_property(this, "href", ""), /**
   * hearsay: who it was heard from
   *
   * @generated from field: string byline = 10;
   */ _define_property(this, "byline", ""), /**
   * @generated from field: string occurred_on = 11;
   */ _define_property(this, "occurredOn", ""), /**
   * hearsay: the labelled line shown in the rail and the Assist context
   *
   * @generated from field: string label_line = 12;
   */ _define_property(this, "labelLine", ""), /**
   * hearsay audience (REG): personal | team | people | everyone
   *
   * @generated from field: string audience_kind = 13;
   */ _define_property(this, "audienceKind", ""), /**
   * @generated from field: string audience_label = 14;
   */ _define_property(this, "audienceLabel", ""), /**
   * @generated from field: bool is_own = 15;
   */ _define_property(this, "isOwn", false), /**
   * hearsay: why it is here ("about DISA, the issuing office")
   *
   * @generated from field: string relevance = 16;
   */ _define_property(this, "relevance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkspaceSource, "runtime", proto3);
_define_property(WorkspaceSource, "typeName", "mono.projectdata.v1.WorkspaceSource");
_define_property(WorkspaceSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "quote_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "display_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "similarity_pct",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "byline",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "occurred_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "label_line",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "audience_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "audience_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "is_own",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "relevance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.InsertSourceRequest
 */ export class InsertSourceRequest extends Message {
    static fromBinary(bytes, options) {
        return new InsertSourceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InsertSourceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InsertSourceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InsertSourceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_anchor = 3;
   */ _define_property(this, "sectionAnchor", ""), /**
   * @generated from field: string source_ref = 4;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string base_version_id = 5;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string operation_id = 6;
   */ _define_property(this, "operationId", ""), /**
   * "insert" (default) | "cite_hearsay"
   *
   * @generated from field: string mode = 7;
   */ _define_property(this, "mode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(InsertSourceRequest, "runtime", proto3);
_define_property(InsertSourceRequest, "typeName", "mono.projectdata.v1.InsertSourceRequest");
_define_property(InsertSourceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.InsertSourceResponse
 */ export class InsertSourceResponse extends Message {
    static fromBinary(bytes, options) {
        return new InsertSourceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InsertSourceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InsertSourceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InsertSourceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(InsertSourceResponse, "runtime", proto3);
_define_property(InsertSourceResponse, "typeName", "mono.projectdata.v1.InsertSourceResponse");
_define_property(InsertSourceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- WRT-08 -----
 *
 * @generated from message mono.projectdata.v1.AssistProposalRef
 */ export class AssistProposalRef extends Message {
    static fromBinary(bytes, options) {
        return new AssistProposalRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssistProposalRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssistProposalRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssistProposalRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string conversation_id = 1;
   */ _define_property(this, "conversationId", ""), /**
   * @generated from field: string tool_call_id = 2;
   */ _define_property(this, "toolCallId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssistProposalRef, "runtime", proto3);
_define_property(AssistProposalRef, "typeName", "mono.projectdata.v1.AssistProposalRef");
_define_property(AssistProposalRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tool_call_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ApplyAssistOperationsRequest
 */ export class ApplyAssistOperationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyAssistOperationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyAssistOperationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyAssistOperationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyAssistOperationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional: empty = resolved from document_id
   *
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * the version the proposal was drafted against; empty = no staleness check
   *
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: repeated mono.docs.v1.DocumentOperation operations = 4;
   */ _define_property(this, "operations", []), /**
   * required unless proposal_ref is set (then derived from it)
   *
   * @generated from field: string operation_id = 5;
   */ _define_property(this, "operationId", ""), /**
   * "main" | "new_draft"
   *
   * @generated from field: string target = 6;
   */ _define_property(this, "target", ""), /**
   * new_draft only; empty = "Assist — <first action>"
   *
   * @generated from field: string draft_name = 7;
   */ _define_property(this, "draftName", ""), /**
   * @generated from field: mono.projectdata.v1.AssistProposalRef proposal_ref = 8;
   */ _define_property(this, "proposalRef", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyAssistOperationsRequest, "runtime", proto3);
_define_property(ApplyAssistOperationsRequest, "typeName", "mono.projectdata.v1.ApplyAssistOperationsRequest");
_define_property(ApplyAssistOperationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "operations",
            kind: "message",
            T: DocumentOperation,
            repeated: true
        },
        {
            no: 5,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "draft_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "proposal_ref",
            kind: "message",
            T: AssistProposalRef
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ApplyAssistOperationsResponse
 */ export class ApplyAssistOperationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyAssistOperationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyAssistOperationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyAssistOperationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyAssistOperationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * the document the operations landed in (the draft for new_draft)
   *
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 2;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: string document_key = 3;
   */ _define_property(this, "documentKey", ""), /**
   * set for target = "new_draft"
   *
   * @generated from field: mono.projectdata.v1.WorkspaceDocument draft = 4;
   */ _define_property(this, "draft", void 0), /**
   * true: the base moved under a region the proposal touches; nothing applied
   *
   * @generated from field: bool stale = 5;
   */ _define_property(this, "stale", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyAssistOperationsResponse, "runtime", proto3);
_define_property(ApplyAssistOperationsResponse, "typeName", "mono.projectdata.v1.ApplyAssistOperationsResponse");
_define_property(ApplyAssistOperationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 3,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "draft",
            kind: "message",
            T: WorkspaceDocument
        },
        {
            no: 5,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * ----- WRT-31 -----
 *
 * @generated from message mono.projectdata.v1.CompareVersionsRequest
 */ export class CompareVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompareVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ResponseContainerRef container = 1;
   */ _define_property(this, "container", void 0), /**
   * the from side: document_id at from_version_id
   *
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string from_version_id = 3;
   */ _define_property(this, "fromVersionId", ""), /**
   * @generated from field: string to_version_id = 4;
   */ _define_property(this, "toVersionId", ""), /**
   * the to side's document (a draft vs its main); empty = document_id
   *
   * @generated from field: optional string to_document_id = 5;
   */ _define_property(this, "toDocumentId", void 0), /**
   * limit the result to one section (heading anchor)
   *
   * @generated from field: optional string section_anchor = 6;
   */ _define_property(this, "sectionAnchor", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareVersionsRequest, "runtime", proto3);
_define_property(CompareVersionsRequest, "typeName", "mono.projectdata.v1.CompareVersionsRequest");
_define_property(CompareVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "container",
            kind: "message",
            T: ResponseContainerRef
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "to_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "section_anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.VersionCompareSegment
 */ export class VersionCompareSegment extends Message {
    static fromBinary(bytes, options) {
        return new VersionCompareSegment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VersionCompareSegment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VersionCompareSegment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VersionCompareSegment, a, b);
    }
    constructor(data){
        super(), /**
   * equal | insert | delete
   *
   * @generated from field: string op = 1;
   */ _define_property(this, "op", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VersionCompareSegment, "runtime", proto3);
_define_property(VersionCompareSegment, "typeName", "mono.projectdata.v1.VersionCompareSegment");
_define_property(VersionCompareSegment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "op",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.VersionCompareSection
 */ export class VersionCompareSection extends Message {
    static fromBinary(bytes, options) {
        return new VersionCompareSection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VersionCompareSection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VersionCompareSection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VersionCompareSection, a, b);
    }
    constructor(data){
        super(), /**
   * heading anchor; empty for the unanchored "Other text" block
   *
   * @generated from field: string anchor = 1;
   */ _define_property(this, "anchor", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * equal | changed | added | removed
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: repeated mono.projectdata.v1.VersionCompareSegment segments = 4;
   */ _define_property(this, "segments", []), /**
   * @generated from field: int32 words_added = 5;
   */ _define_property(this, "wordsAdded", 0), /**
   * @generated from field: int32 words_removed = 6;
   */ _define_property(this, "wordsRemoved", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VersionCompareSection, "runtime", proto3);
_define_property(VersionCompareSection, "typeName", "mono.projectdata.v1.VersionCompareSection");
_define_property(VersionCompareSection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "segments",
            kind: "message",
            T: VersionCompareSegment,
            repeated: true
        },
        {
            no: 5,
            name: "words_added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "words_removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CompareVersionsResponse
 */ export class CompareVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompareVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompareVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompareVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompareVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * the to-side's section order, then from-only sections in from order
   *
   * @generated from field: repeated mono.projectdata.v1.VersionCompareSection sections = 1;
   */ _define_property(this, "sections", []), /**
   * true when any region was diffed by paragraph instead of by word
   *
   * @generated from field: bool coarse = 2;
   */ _define_property(this, "coarse", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompareVersionsResponse, "runtime", proto3);
_define_property(CompareVersionsResponse, "typeName", "mono.projectdata.v1.CompareVersionsResponse");
_define_property(CompareVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sections",
            kind: "message",
            T: VersionCompareSection,
            repeated: true
        },
        {
            no: 2,
            name: "coarse",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
